import { Doc } from 'tiptap';

export default class TextDocNode extends Doc {
  get name() {
    return 'doc';
  }

  get schema() {
    return {
      content: '(paragraph | heading | bullet_list | ordered_list)+',
    };
  }
}
